import { useEffect, useState } from "react"
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Stack,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { useLazyGetShopPoliciesQuery } from "src/features/checkout/storefrontApi"
import { useDispatch, useSelector } from "react-redux"
import { setSelectedShopPolicy } from "src/features/checkout/checkoutSlice"

const links = {
  refundPolicy: {
    url: "//kakaakowine.com/policies/refund-policy",
    title: "Refund Policy",
  },
  shippingPolicy: {
    url: "//kakaakowine.com/policies/shipping-policy",
    title: "Delivery policy",
  },
  privacyPolicy: {
    url: "//kakaakowine.com/policies/privacy-policy",
    title: "Privacy policy",
  },
  termsOfService: {
    url: "//kakaakowine.com/policies/terms-of-service",
    title: "Terms of service",
  },
  subscriptionPolicy: {
    url: "//kakaakowine.com/policies/subscription-policy",
    title: "Subscription policy",
  },
}

export default () => {
  const dispatch = useDispatch()
  const selectedShopPolicy = useSelector(
    (state) => state.checkout.selectedShopPolicy,
  )
  const [open, setOpen] = useState(false)
  const [getShopPolicies, { data, isLoading }] = useLazyGetShopPoliciesQuery()

  const closeDialog = (event) => {
    event.preventDefault()
    setOpen(false)
    setTimeout(() => {
      dispatch(setSelectedShopPolicy(null))
    }, 100)
  }

  useEffect(() => {
    if (selectedShopPolicy) {
      if (!data) {
        getShopPolicies()
      }
      setOpen(true)
    }
  }, [selectedShopPolicy])

  return (
    <Box
      sx={{
        borderTop: "#eee 1px solid",
        mt: "auto",
        padding: "16px 0 8px",
      }}
    >
      <Stack direction="row" spacing={1}>
        {Object.keys(links).map((key) => {
          const link = links[key]
          return (
            <Link
              key={key}
              color="#ab211c"
              href={link.url}
              fontSize={12}
              onClick={(e) => {
                e.preventDefault()
                dispatch(setSelectedShopPolicy(key))
              }}
            >
              {link.title}
            </Link>
          )
        })}
      </Stack>

      <Dialog maxWidth="md" fullWidth onClose={closeDialog} open={open}>
        <DialogTitle sx={{ m: 0, p: 2 }} onClose={closeDialog}>
          {links[selectedShopPolicy]?.title}
          <IconButton
            aria-label="close"
            onClick={closeDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 12,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: 2 }}>
          {isLoading ? (
            <Box
              sx={{
                minHeight: "200px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Box
              dangerouslySetInnerHTML={{
                __html: data?.shop[selectedShopPolicy]?.body,
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  )
}
